import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getAllLangs } from '../../utils/lang';
import Button from '../common/Button';
import Modal from '../common/Modal';
import SelectField from '../Form/SelectField';
import './styles.scss';

const PdfModal = ({ language, handleSubmit, onClose }) => {
    const { t } = useTranslation();
    const languages = getAllLangs();

    const [pdfLanguage, setPdfLanguage] = useState(language);

    return (
        <Modal
            closeModal={onClose}
            fullscreen
            title={t('pdfModal.title')}
        >
            <div className="modal-pdfLanguage">
                <SelectField
                    input={{
                        name: 'language',
                        onChange: (value) => setPdfLanguage(value),
                        value: pdfLanguage,
                    }}
                    label={t('pdfModal.field.language.title')}
                    menuPortalTarget={document.body}
                    options={languages.map(({ keyLang, label }) => ({
                        value: keyLang,
                        label,
                    }))}
                    styles={{ menuPortal: (base) => ({ ...base, zIndex: 200 }) }}
                />
                    <Button
                        aria-label={t('common.download_report')}
                        className="button--black button--block base-margin"
                        text={t('pdfModal.action.title')}
                        onClick={() => handleSubmit(pdfLanguage)}
                    />
            </div>
        </Modal>
    );
};

PdfModal.propTypes = {
    formId: PropTypes.string.isRequired,
    language: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default PdfModal;
